"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.createLogger = exports.setLogLevel = exports.globalLogLevel = exports.logTransports = exports.globalMetadata = void 0;
/* eslint-disable prefer-rest-params */
const types_1 = require("../types");
const utils_1 = require("../utils");
const consoleTransport_1 = require("./consoleTransport");
const utils_2 = require("./utils");
__exportStar(require("./consoleTransport"), exports);
__exportStar(require("./datadogTransport"), exports);
exports.globalMetadata = {};
exports.logTransports = [(0, consoleTransport_1.consoleTransport)()];
/**
 * Sets the global log level.
 */
function setLogLevel(level) {
    exports.globalLogLevel = level !== null && level !== void 0 ? level : undefined;
}
exports.setLogLevel = setLogLevel;
/**
 * Creates a Logger Instance.
 */
function createLogger(options = {}) {
    var _a;
    const rootMetadata = (_a = options.metadata) !== null && _a !== void 0 ? _a : {};
    const logger = {
        // impl loosely based on Winston Logger's dynamic log function
        // https://github.com/winstonjs/winston/blob/master/lib/winston/logger.js
        log() {
            var _a, _b;
            let logInfo;
            // Optimize for the hotpath of logging JSON literals
            if (arguments.length === 1) {
                logInfo = {
                    level: types_1.LogLevel.Info,
                    ...arguments[0],
                };
            }
            // Slightly less hotpath, but worth optimizing for.
            else if (arguments.length === 2) {
                const [level, message] = Array.from(arguments);
                if (message && typeof message === 'object') {
                    logInfo = {
                        ...message,
                        level: (_a = message.level) !== null && _a !== void 0 ? _a : level,
                    };
                }
                else {
                    logInfo = {
                        level,
                        message,
                    };
                }
            }
            else {
                const [level, message, ...splat] = Array.from(arguments);
                const [meta] = splat;
                if (typeof meta === 'object' && meta !== null) {
                    logInfo = {
                        ...meta,
                        level,
                        splat: splat.slice(1),
                        message,
                    };
                    if (meta.message) {
                        logInfo.message = `${(0, utils_2.getLogMessage)(logInfo.message)} ${(0, utils_2.getLogMessage)(meta.message)}`;
                    }
                    if (meta.stack) {
                        logInfo.stack = meta.stack;
                    }
                }
                else {
                    logInfo = {
                        level,
                        splat,
                        message,
                    };
                }
            }
            // Check if we should log this message
            const minLevel = exports.globalLogLevel !== null && exports.globalLogLevel !== void 0 ? exports.globalLogLevel : options.logLevel;
            if (minLevel && !(0, utils_2.isAboveLevel)(logInfo.level, minLevel)) {
                return logger;
            }
            // Add timestamp and root metadata.
            // Ensure there is a message property.
            logInfo = {
                ...exports.globalMetadata,
                ...rootMetadata,
                timestamp: new Date().toISOString(),
                ...logInfo,
                message: (_b = logInfo.message) !== null && _b !== void 0 ? _b : '',
            };
            for (const transport of exports.logTransports) {
                if (transport.logLevel) {
                    if (!(0, utils_2.isAboveLevel)(logInfo.level, transport.logLevel)) {
                        continue;
                    }
                }
                transport.log({
                    ...(0, utils_1.filterReporterMetadata)(logInfo, transport),
                    // These would break the transport if excluded.
                    level: logInfo.level,
                    message: logInfo.message,
                    splat: logInfo.splat,
                });
            }
            return logger;
        },
        child(metadata) {
            return createLogger({ ...rootMetadata, metadata });
        },
        startTimer() {
            const start = new Date();
            return {
                logger: this,
                done: ({ message, level, metadata } = {}) => {
                    const duration = new Date().getTime() - start.getTime();
                    logger.log(level !== null && level !== void 0 ? level : types_1.LogLevel.Info, message !== null && message !== void 0 ? message : 'Timer Completed', { duration, ...(metadata !== null && metadata !== void 0 ? metadata : {}) });
                    return true;
                },
            };
        },
        // Forward the log levels into the log function, essentially shortcuts.
        debug: (...args) => logger.log(types_1.LogLevel.Debug, ...args),
        info: (...args) => logger.log(types_1.LogLevel.Info, ...args),
        warn: (...args) => logger.log(types_1.LogLevel.Warn, ...args),
        error: (...args) => logger.log(types_1.LogLevel.Error, ...args),
    };
    return logger;
}
exports.createLogger = createLogger;
exports.logger = createLogger();
//# sourceMappingURL=index.js.map